import React, { useState, useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getFeatureFromDb } from "../redux/slices/getFeatureSlice";
import { addRoleToDb, clearAddRoleState } from "../redux/slices/addRoleSlice";
import {
  editRoleToDb,
  clearEditRoleState,
} from "../redux/slices/editRoleDataSlice";
import Axios from "axios";
import { getToPathname } from "@remix-run/router";
import { setShowMessage } from "../redux/slices/notificationSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { GridToolbar } from "@mui/x-data-grid";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
// import { Modal, Button } from "react-bootstrap";
import {
  Box,
  TextField,
  Typography,
  Button,
  Grid,
  Switch,
  Paper,
  Checkbox,
  Card,
  CardContent,
  Tooltip,
  IconButton,
  InputLabel,
  FormControl,
  FilledInput,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import InfoIcon from "@mui/icons-material/Info";
import translations from "../assets/locals/translations";
import "../styles/roles.css";
export default function AddRole({ workFor }) {
  const location = useLocation();
  const tableEditData = location.state;
  // console.log(tableEditData,"tableEditDatatableEditData")
  const [featuresList, setFeaturesList] = useState([]);
  const [showRolesList, setShowRolesList] = useState([]);
  const [checkedd, setChecked] = useState(false);
  const [role_emp, setRole_emp] = useState(0);
  // console.log("ddddddd",checkedd)
  const [currentRole, setCurrentRole] = useState({
    role: null,
    features: null,
  });

  const [featureData, setFeatureData] = useState({
    roleName: "",
    roleDescription: "",
    checkedFeatures: [],
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations['en'];
  const featuresState = useSelector(
    (state) => state.featuresListState.featuresState
  );
  const addRoleState = useSelector((state) => state.addRoleState.addRoleState);
  const editRoleState = useSelector(
    (state) => state.editRoleDataState.editRoleSliceState
  );

  const handleCheckboxChange = () => {
    setChecked(!checkedd);
    setRole_emp(1);
  };

  useEffect(() => {
    if (workFor === "forEdit") {
      setFeatureData({
        roleName: tableEditData.role,
        roleDescription: tableEditData.description,
        checkedFeatures: [],
      });
    }
  }, [workFor]);

  useEffect(() => {
    // console.log('editRoleState', editRoleState);
    if (editRoleState.isSuccess) {
      if (
        editRoleState.message.isSuccess &&
        editRoleState.message.result === "success"
      ) {
        dispatch(setShowMessage("Success"));
        dispatch(clearEditRoleState());
        clearInpHook();
        navigate("/administration/roles");
      }
    }
  }, [editRoleState]);

  function clearInpHook() {
    setFeatureData({
      roleName: "",
      roleDescription: "",
      checkedFeatures: [],
    });
    // setChecked(false)
    const allInp = document.getElementsByClassName("inputElement");
    Array.from(allInp).forEach((item) => {
      if (item.type === "checkbox") {
        item.checked = false;
      } else {
        item.value = "";
      }
    });
  }
  useEffect(() => {
    getRoleEmp();
  }, []);
  const getRoleEmp = async () => {
    const RoleForEmp = tableEditData.id;
    const url = `${process.env.REACT_APP_NODE_URL}/api/users/getRoleDesc/${RoleForEmp}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data?.isSuccess) {
        setRole_emp(response.data.result[0].role_emp);
        // console.log(response.data.result, "6666666666666666666666666")
        if (response.data.result[0].role_emp == 1) {
          setChecked(true);
        } else {
          setChecked(false);
        }
      }
    });
  };

  useEffect(() => {
    if (workFor === "forEdit") {
      clearInpHook(); // Clear input fields

      // Set role data
      if (tableEditData.role) {
        setFeatureData((prev) => ({
          ...prev,
          roleName: tableEditData.role,
          roleDescription: tableEditData.description,
        }));
      }

      // Set checked features
      if (currentRole.features) {
        const tempAr = currentRole.features.map((feature) => feature.id);
        setFeatureData((prev) => ({
          ...prev,
          checkedFeatures: tempAr,
        }));
      }
    }
  }, [currentRole]);

  useEffect(() => {
    clearInpHook();
    if (workFor === "forEdit") {
      getRoles();
    }
  }, [workFor]);
  useEffect(() => {
    if (addRoleState.isSuccess) {
      if (addRoleState.message.isSuccess) {
        dispatch(setShowMessage(t.roleiscreated || "Role is created"));
        dispatch(clearAddRoleState());
        navigate("/administration/roles");
        clearInpHook();
        clearAddRoleState();
      } else {
        dispatch(setShowMessage(t.somethingwrong || "Something is wrong"));
      }
    }
  }, [addRoleState]);
  useEffect(() => {
    if (featuresState.isSuccess) {
      if (featuresState.data.isSuccess) {
        setFeaturesList(featuresState.data.result);
      } else {
        setFeaturesList([]);
      }
    }
  }, [featuresState]);

  useEffect(() => {
    dispatch(getFeatureFromDb());
  }, []);

  function onChangeHandler(event, featureId) {
    const { name, value, checked, type } = event.target;

    if (type === "checkbox") {
      setFeatureData((prevData) => {
        const isChecked = prevData.checkedFeatures.includes(featureId);
        const updatedFeatures = isChecked
          ? prevData.checkedFeatures.filter((id) => id !== featureId)
          : [...prevData.checkedFeatures, featureId];

        return { ...prevData, checkedFeatures: updatedFeatures };
      });
    } else {
      setFeatureData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  }

  async function getRoles() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/roles/get-roles-to-edit`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data?.isSuccess) {
        setShowRolesList(response.data.result);
        // console.log('get-roles-to-edit result>', response.data.result);
      }
    });
  }
  async function getRoleFeatures(roleId) {
    const url = `${process.env.REACT_APP_NODE_URL}/api/roles/get-roles-features`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.post(url, { roleId: roleId }, config).then((response) => {
      if (response.data?.isSuccess) {
        // setShowRolesList(response.data.result)
        setCurrentRole((currentRole) => ({
          ...currentRole,
          features: response.data.result,
        }));
      }
    });
  }
  function handleSubmit() {
    const updatedObject = {
      ...featureData,
    };
    if (workFor === "addRole") {
      if (
        featureData.roleName != "" &&
        featureData.checkedFeatures.length > 0
      ) {
        console.log(updatedObject, "updatedObject");
        dispatch(addRoleToDb(updatedObject));
      } else {
        dispatch(setShowMessage(t.pleasefillallfield || "Please fill all the field"));
      }
    } else {
      if (workFor === "forEdit") {
        if (currentRole != null) {
          let myData = {
            description: featureData.roleDescription,
            features: featureData.checkedFeatures,
            id: tableEditData.id,
          };
          dispatch(editRoleToDb(myData));
        }
      }
    }
  }
  function handleSelectRole() {
    // console.log('handleSelectRole', e.target.selectedOptions[0].value);
    clearInpHook();
    let tempObj = showRolesList.find((item) => {
      return item.id == tableEditData.id;
    });
    setCurrentRole((currentRole) => ({ ...currentRole, role: tempObj }));
    getRoleFeatures(tableEditData.id);
  }
  function handlCancel() {
    // console.log(featureData.roleDescription);
    navigate("/administration/roles");
    clearInpHook();
  }

  const getEdit = () => {
    if (workFor === "forEdit") {
      setFeatureData({
        roleName: tableEditData.role,
        roleDescription: tableEditData.description,
        checkedFeatures: [],
      });
    }
  };
  useEffect(() => {
    if (workFor === "forEdit") {
      getEdit();
      handleSelectRole();
    }
  }, []);

  const redirectModal = () => {
    navigate(-1);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        maxWidth: 1200,
        margin: "auto",
        padding: 4,
        borderRadius: 1,
        backgroundColor: "#fbfcfc",
      }}
    >
      {/* Header Section */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h6" fontWeight="600" className="text-muted">
          {workFor === "addRole" ? t.newrole || "New Role" : t.editrole || "Edit Role"}
        </Typography>
        <Box display="flex" gap={2}>
          <Button
            startIcon={<ArrowBackIcon />}
            variant="outlined"
            sx={{ borderRadius: 1, paddingX: 3 }}
            onClick={() => navigate(-1)}
          >
            {t.back || "Back"}
          </Button>
          {/* {workFor === "addRole" && (
            <Button
              startIcon={<AddCircleOutlineIcon />}
              variant="outlined"
              sx={{ borderRadius: 1, paddingX: 3 }}
            >
              {t.addrole || "Add Role"}
            </Button>
          )} */}
        </Box>
      </Box>

      <Grid container spacing={2} mb={3}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth variant="filled" sx={{ mb: 1 }}>
            <InputLabel
              sx={{ fontSize: "1rem", fontWeight: 500, color: "#555" }}
            >
              {t.rolename || "Role Name"}
            </InputLabel>
            <FilledInput
              disableUnderline
              name="roleName"
              value={featureData.roleName}
              onChange={onChangeHandler}
              placeholder={t.enterrolename || "Enter the role name"}
              disabled={workFor === "forEdit"}
              sx={{
                borderRadius: 2,
                backgroundColor: "#f5f5f5",
                "&:hover": { backgroundColor: "#e8e8e8" },
                "&.Mui-focused": {
                  backgroundColor: "#fff",
                  boxShadow: "0 0 6px rgba(0, 123, 255, 0.3)",
                },
              }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth variant="filled" sx={{ mb: 1 }}>
            <InputLabel
              sx={{ fontSize: "1rem", fontWeight: 500, color: "#555" }}
            >
              {t.roledescription || "Role Description"}
            </InputLabel>
            <FilledInput
              disableUnderline
              multiline
              rows={3}
              name="roleDescription"
              value={featureData.roleDescription}
              onChange={onChangeHandler}
              placeholder={t.enteroledescription || "Enter a description for the role"}
              sx={{
                borderRadius: 2,
                backgroundColor: "#f5f5f5",
                "&:hover": { backgroundColor: "#e8e8e8" },
                "&.Mui-focused": {
                  backgroundColor: "#fff",
                  boxShadow: "0 0 6px rgba(0, 123, 255, 0.3)",
                },
              }}
            />
          </FormControl>
        </Grid>
      </Grid>

      {/* Assigned Features Header with Info Icon */}
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <Typography variant="h6" fontWeight="medium">
          {t.assignedfeatures || "Assigned Features"}
        </Typography>
        <Tooltip title={t.selectfeatures || "Select the features you want to assign to this role."}>
          <IconButton size="small" color="info">
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Features Grid Section */}
      <Grid container spacing={3}>
        {featuresList.map((feature, index) => {
          const isSelected = featureData.checkedFeatures.includes(feature.id); // Check if the feature is selected

          return (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: 2,
                  backgroundColor: "#fff",
                  borderRadius: 2, // Smooth rounded corners
                  boxShadow: isSelected
                    ? "0 6px 16px rgba(76, 175, 80, 0.4)" // Green shadow when selected
                    : "0 4px 12px rgba(0, 0, 0, 0.1)", // Default shadow
                  border: "1.5px solid transparent", // Subtle border width
                  borderImage: isSelected
                    ? "linear-gradient(45deg, #4caf50, #2196f3) 1" // Green to Blue gradient
                    : "linear-gradient(45deg, transparent, transparent) 1", // Transparent border when not selected
                  transition:
                    "transform 0.2s, box-shadow 0.2s, border-image 0.2s",
                  "&:hover": { transform: "scale(1.02)" }, // Smooth hover effect
                }}
              >
                <Checkbox
                  edge="start"
                  checked={isSelected}
                  onChange={(e) => onChangeHandler(e, feature.id)}
                  sx={{ marginRight: 2 }}
                />
                <Box flex={1}>
                  <Tooltip title={feature.description || "Feature Info"}>
                    <Typography
                      className="text-uppercase"
                      variant="subtitle1"
                      fontWeight="medium"
                    >
                      {feature.label}
                    </Typography>
                  </Tooltip>
                  <Typography
                    className="text-muted"
                    variant="body2"
                    color="textSecondary"
                    sx={{ fontSize: "0.85rem", marginTop: 0.5 }}
                  >
                    {feature.description ||
                      "This feature provides access to relevant tools and permissions."}
                  </Typography>
                </Box>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {/* Action Buttons - Aligned to the Left */}
      <Box display="flex" justifyContent="flex-start" gap={2} mt={4}>
        <Button
          startIcon={<SaveIcon />}
          variant="outlined"
          color="primary"
          onClick={handleSubmit}
          sx={{
            borderRadius: 1,
            paddingX: 2,
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          {workFor === "addRole" ? t.createrole || "Create Role" : t.savechanges || "Save Changes"}
        </Button>
        <Button
          startIcon={<CancelIcon />}
          variant="outlined"
          color="error"
          onClick={handlCancel}
          sx={{
            borderRadius: 1,
            paddingX: 2,
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          {t.cancel || "Cancel"}
        </Button>
      </Box>
    </Paper>
  );
}
